import { CloseButton } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Flex } from "#shared/view/components/Flex";
import { Title } from "#shared/view/components/Title";
import { TextInput } from "#shared/view/designSystem/inputs/TextInput";

type Props = { search: string; setSearch: (search: string) => void };

export const QuoteRequestLinesSearchBar = ({ search, setSearch }: Props) => {
  const { t } = useTranslation();

  const searchPartEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return (
    <Flex justify="space-between" align="center" w="100%">
      <Title order={1}>{t("qrl.searchbar.title")}</Title>
      <TextInput
        value={search}
        onChange={searchPartEvent}
        placeholder={t("qrl.searchbar.placeholder")}
        miw={500}
        rightSection={
          <CloseButton
            aria-label="Clear input"
            onClick={() => setSearch("")}
            style={{ display: search ? undefined : "none" }}
          />
        }
      />
    </Flex>
  );
};
